import * as yup from "yup";
const phoneRegExp =
  /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/;
// const phoneRegExp = /^(?:\+234\d{10}|0\d{10})$/;

const PersonalValidator = yup.object({
  firstname: yup.string().required("First name is required"),
  lastname: yup.string().required("Last name is required"),
  phone_number: yup.string().matches(phoneRegExp, "Phone number is not valid"),
  email: yup.string().email().required("Email is required"),
});

export { PersonalValidator };
